import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Subject, filter, takeUntil } from 'rxjs';
import { AuthenticatedWrapperComponent } from './shared/components/authenticated-wrapper/authenticated-wrapper';
import { AuthService } from './shared/services/auth.service';
import { ClaimsResponse } from './shared/models/auth.models';
import { ToastModule } from 'primeng/toast';
import { shouldUseAuthenticatedLayout } from './shared/utils/layout-mode.utils';

@Component({
    selector: 'app-root',
    imports: [
        RouterOutlet,
        AuthenticatedWrapperComponent,
        ToastModule,
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppRootComponent implements OnInit, OnDestroy {

    public title: string = 'tradein-holdings-spa';

    private _authService: AuthService = inject(AuthService);
    private _router: Router = inject(Router);
    private _cdr: ChangeDetectorRef = inject(ChangeDetectorRef);
    private _destroy$: Subject<void> = new Subject<void>();

    public useAuthenticatedLayout: boolean = shouldUseAuthenticatedLayout(this._router.url);

    public ngOnInit(): void {
        this._router.events
            .pipe(
                filter((ev): ev is NavigationEnd => ev instanceof NavigationEnd),
                takeUntil(this._destroy$)
            )
            .subscribe((ev: NavigationEnd): void => {
                const next: boolean = shouldUseAuthenticatedLayout(ev.urlAfterRedirects);
                if (next !== this.useAuthenticatedLayout) {
                    this.useAuthenticatedLayout = next;
                    this._cdr.markForCheck();
                }
            });
    }

    public ngOnDestroy(): void {
        this._destroy$.next();
        this._destroy$.complete();
    }

    public get getClaims(): ClaimsResponse | undefined {
        return this._authService.getClaims();
    }

    public get isAuthenticated(): boolean {
        return this._authService.isAuthenticated;
    }

}
